export const TIER_STYLES = {
  common: {
    border: 'border-white/15',
    text: 'text-text-secondary',
    glow: 'rgba(160,160,160,0.18)'
  },
  rare: {
    border: 'border-info/40',
    text: 'text-info',
    glow: 'rgba(77,220,255,0.2)'
  },
  epic: {
    border: 'border-violet-400/45',
    text: 'text-violet-300',
    glow: 'rgba(167,139,250,0.22)'
  },
  legendary: {
    border: 'border-amber-400/50',
    text: 'text-amber-300',
    glow: 'rgba(251,191,36,0.24)'
  }
}

export const getTierStyle = (tier) => TIER_STYLES[tier] || TIER_STYLES.common

const toNumber = (value) => {
  const number = Number(value)
  return Number.isFinite(number) ? number : 0
}

const formatNumber = (value, language, maximumFractionDigits = 0) => new Intl.NumberFormat(language, {
  maximumFractionDigits
}).format(toNumber(value))

const formatDecimal = (value, language) => formatNumber(value, language, 2)

export const formatOwnersPercent = (value, language) => formatDecimal(value, language)

export const getProgressView = (achievement, t, language) => {
  if (achievement.earned) {
    return { label: t('achievements.earned'), showBar: false, ratio: 1 }
  }

  const progress = achievement.progress
  if (!progress) return null

  const current = progress.current
  const target = toNumber(progress.target)
  const ratio = target > 0 ? Math.min(toNumber(current) / target, 1) : 0

  if (progress.unit === 'flag') {
    return { label: t('achievements.notEarnedYet'), showBar: false, ratio: 0 }
  }

  if (progress.unit === 'chance') {
    if (current == null) {
      return { label: t('achievements.noWinsYet'), showBar: false, ratio: 0 }
    }

    return {
      label: t('achievements.bestChance', {
        current: formatDecimal(current, language),
        target: formatDecimal(target, language)
      }),
      showBar: false,
      ratio: target > 0 && toNumber(current) > 0 ? Math.min(target / toNumber(current), 1) : 0
    }
  }

  if (progress.unit === 'crystals') {
    return {
      label: t('achievements.crystalsProgress', {
        current: formatNumber(current, language),
        target: formatNumber(target, language)
      }),
      showBar: true,
      ratio
    }
  }

  if (progress.unit === 'usd') {
    return {
      label: t('achievements.usdProgress', {
        current: formatDecimal(current, language),
        target: formatDecimal(target, language)
      }),
      showBar: true,
      ratio
    }
  }

  if (progress.unit === 'multiplier') {
    return {
      label: t('achievements.multiplierProgress', {
        current: formatDecimal(current, language),
        target: formatDecimal(target, language)
      }),
      showBar: true,
      ratio
    }
  }

  if (progress.unit === 'days') {
    return {
      label: t('achievements.daysProgress', {
        current: formatNumber(current, language),
        target: formatNumber(target, language)
      }),
      showBar: true,
      ratio
    }
  }

  return {
    label: t('achievements.countProgress', {
      current: formatNumber(current, language),
      target: formatNumber(target, language)
    }),
    showBar: true,
    ratio
  }
}
